import { createComponent } from '@mtfe/sweet';
import { eventBus } from '@mtfe/sweet-utils';

import { COUPON_STATUS } from '../../constants/index';
import componentUtils from '../../utils/index';
import style from './style.less';
import tpl from './dom.html';

const { getGiftEventName } = componentUtils;


const GoodsCounpon = (props) => {
    const { poiInfo, onCounponAndGooodsClick, couponSubtitle, hiddenCb } = props;

    const data = {
        poiInfo,
        couponSubtitle,
        hasRecive: poiInfo.giftInfo.status === COUPON_STATUS.STATUS_RECEIVED
    };

    // 注册单张券事件
    const { gift_id: giftId } = poiInfo.giftInfo;
    const eventName = getGiftEventName(giftId);
    eventBus.$onceOn(eventName, (newStatus) => {
        const selector = `[data-gift-id=gift-id${giftId}]`;
        const btnDomList = Array.from(document.querySelectorAll(selector));
        if (btnDomList.length) {
            btnDomList.forEach((btnDom) => {
                if (newStatus === COUPON_STATUS.STATUS_NEW) {
                    btnDom.innerText = '立即领取';
                    btnDom.classList.remove(style.useBtn);
                    btnDom.classList.add(style.recivBtn);
                } else if (newStatus === COUPON_STATUS.STATUS_RECEIVED) {
                    btnDom.innerText = '去使用';
                    btnDom.classList.remove(style.recivBtn);
                    hiddenCb();
                    btnDom.classList.add(style.useBtn);
                }
            });
        }
    });

    const events = {
        handleGoodsAndCounponClick: (index) => {
            if (index >= 0) {
                onCounponAndGooodsClick && onCounponAndGooodsClick(poiInfo, index);
            } else {
                onCounponAndGooodsClick && onCounponAndGooodsClick(poiInfo, -1);
            }
        },
    }

    const component = createComponent(tpl, { data, style }, events);
    return component;
};
export default GoodsCounpon;
